<template>
  <div class="container">
    <div id="topmenu">
      <a class="c-menu-btn container" v-on:click="open_menu()">
        <font-awesome-icon icon="bars" class="c-menu-btn_icon" />
        <small>メニュー</small>
      </a>
      <div class="c-scroll-menu" v-show="showmenu" v-on:click="open_menu()">
        <a>
          <font-awesome-icon icon="bars" class="c-menu-btn_icon" />
          <small>メニュー</small>
        </a>
      </div>
      <div
        class="c-backmenu"
        v-show="back_menu"
        v-on:touchstart.prevent="close_menu()"
        v-on:mousedown.prevent="close_menu()"
      >
        <a class="c-backmenu-close">
          <font-awesome-icon icon="times" class="times" />
          <span>閉じる</span>
        </a>
      </div>

      <transition name="right" v-on:after-leave="afterleave">
        <div class="c-openmenu" v-show="menu" v-on:scroll.stop v-on:touchmove.stop ref="menu">
          <ul class="c-openmenu-ul" v-for="(i, index) in menu_data" v-bind:key="index">
            <h2 class="c-openmenu-ul_title">{{ i.title }}</h2>
            <li v-for="(ii, index) in i.item_data" v-bind:key="index" class="c-openmenu-li">
              <div v-bind:class="{ active: ii.img || open_catename === ii.namae && ii.namae }">
                <a
                  v-on:click="open_cate(ii.namae,ii.url,$event)"
                  v-bind:href="ii.url"
                  class="c-openmenu-li_a"
                >
                  <img v-bind:src="ii.img" v-if="ii.img" />
                  <font-awesome-icon
                    icon="pencil-alt"
                    class="c-openmenu-li_a-icon"
                    v-if="ii.icon == 'pen'"
                  />
                  <font-awesome-icon
                    icon="image"
                    class="c-openmenu-li_a-icon"
                    v-if="ii.icon == 'image'"
                  />
                  <span class="c-openmenu-li_span">{{ ii.name }}</span>

                  <font-awesome-icon v-bind:icon="check_angle(ii)" class="c-openmenu_angle" />
                </a>
              </div>

              <transition
                name="slide"
                v-on:before-enter="beforeEnter"
                v-on:enter="enter"
                v-on:before-leave="beforeLeave"
                v-on:leave="leave"
              >
                <ul v-show="open_catename == ii.namae" class="c-openmenu-cate">
                  <li
                    v-for="(iii, index) in ii.cate"
                    v-bind:key="index"
                    class="c-openmenu-cate-item"
                  >
                    <a v-bind:href="iii.url" class="c-openmenu-cate-item_a">
                      <img v-bind:src="iii.img" v-if="iii.img">
                      <span class="c-openmenu-cate-item_span">{{ iii.name }}</span>
                      <font-awesome-icon icon="angle-right" class="c-openmenu_angle cate-angle" />
                    </a>
                  </li>
                </ul>
              </transition>
            </li>
          </ul>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import scrollIntoView from "dom-scroll-into-view";
import { MenuEvent } from "./MenuEvent";
var now;
export default {
  name: "app",
  components: {},
  data() {
    return {
      menu: false,
      back_menu: false,
      open_catename: "",
      showmenu: false,
      menu_data: ""
    };
  },
  methods: {
    beforeEnter: function(el) {
      el.style.height = "0";
    },
    enter: function(el) {
      el.style.height = el.scrollHeight + "px";
    },
    beforeLeave: function(el) {
      el.style.height = el.scrollHeight + "px";
    },
    leave: function(el) {
      el.style.height = "0";
    },

    //メニューアイコンの向き判定
    check_angle(ii) {
      if (ii.cate) {
        if (ii.namae == this.open_catename) {
          return "angle-up";
        }
        return "angle-down";
      }
      return "angle-right";
    },
    //メニュー画面表示
    open_menu() {
      this.menu = true;
      this.back_menu = true;
      now = window.pageYOffset;
      window.scrollTo(0, -now);
      var self = this;
      this.$nextTick(function() {
        disableBodyScroll(self.$refs.menu, { reserveScrollBarGap: true });
      });
    },
    close() {
      this.menu = false;
      this.back_menu = false;
      enableBodyScroll(this.$refs.menu);
    },
    //メニュー画面非表示
    close_menu() {
      this.close();
      window.scrollTo(0, now);
    },
    afterleave() {
      this.back_menu = false;
    },

    //カテゴリー詳細表示
    open_cate(index, url, event) {
      var self = this;
      if (index == this.open_catename) {
        this.open_catename = "";
      } else {
        this.open_catename = index;
        setTimeout(function() {
          scrollIntoView(event.target, self.$refs.menu, { offsetTop: 300 });
        }, 600);
      }
      if (!url) {
        event.preventDefault();
      } else {
        this.close();
      }
    },

    scroll_menu() {
      var header = document.getElementById("header");
      var h = header.clientHeight;
      var y = window.pageYOffset;
      if (h < y) {
        this.showmenu = true;
      } else {
        this.showmenu = false;
      }
    }
  },
  mounted() {
    var self = this;
    document.addEventListener("scroll", this.scroll_menu);
    MenuEvent.$on("setMenu", function(data) {
      self.menu_data = data;
    });
  }
};
</script>

<style lang="scss">
#header .right-menu li {
  #topmenu {
    .c-menu-btn {
      &_icon {
        font-size: 2em;
      }
    }
    .c-scroll-menu {
      position: fixed;
      top: 1%;
      right: 3%;
      background: rgba(240, 237, 228, 0.8);
      padding: 2%;
      border: #a1a1a1 solid 1px;
      border-radius: 10px;
      z-index: 9999;
    }

    .c-backmenu {
      background-color: rgba(0, 0, 0, 0.3);
      height: 100vh;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 9998;
      &-close {
        color: #fff;
        margin-top: 5%;
        .times {
          font-size: 270%;
        }
      }
    }

    .c-openmenu {
      height: 100%;
      width: 85%;
      position: fixed;
      top: 0;
      right: 0;
      overflow: scroll;
      -webkit-overflow-scrolling: touch;
      z-index: 9999;
      &-ul {
        overflow: hidden;
        &_title {
          background-color: #3f3416;
          color: #fff;
          margin: 0;
          padding: 1% 5%;
          font-size: 120%;
        }
      }

      &-li {
        border-bottom: #6d5509b0 solid 1px;
        font-size: 130%;
        overflow: hidden;
        float: none;
        background-color: #fff;
        .active {
          background-color: #d3c8a5b2;
        }
        &_a {
          display: flex;
          flex-direction: inherit;
          justify-content: flex-start;
          padding: 3%;
          width: 100%;
          float: none;
          text-decoration: none;
          &-icon {
            margin-right: 3%;
          }
        }
        &_span {
          flex: 1;
        }
      }
      &-cate {
        height: 100%;
        &-item {
          float: none;
          border-top: solid 1px #6d5509b0;
          width: 100%;
          display: flex;
          align-items: center;
          background-color: #f3ecd9d5;
          &_a {
            text-decoration: none;
            flex-direction: initial;
            padding: 3%;
            width: 100%;
            display: flex;
            justify-content: left;
            position: relative;
          }
          .cate-angle {
            position: absolute;
            right: 3%;
          }
          &_span {
            margin-left: 3%;
          }
        }
      }
      &_angle {
        color: #5c5c5c;
        right: 8%;
        margin: 0 5%;
      }

      img {
        width: 30px;
        height: 30px;
        margin-right: 2%;
      }

      &-search {
        border: 1px solid #3f3416;
        border-bottom: solid 3px #3f3416;
        background-color: #f0ede4;
        border-radius: 6px;
        width: 85%;
        display: flex;
        align-items: center;
        margin: 3% auto;
        padding: 2%;
        font-size: 120%;
        float: none;
        flex-direction: inherit;
        text-decoration: none;
        &_loupe {
          font-size: 150%;
          position: relative;
          left: -3%;
        }
        &_angle {
          position: relative;
          right: -8%;
        }
      }
    }
  }
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.5s;
  max-height: 1000px;
}
.slide-enter,
.slide-leave-to {
  max-height: 0px;
}

.right-enter-active,
.right-leave-active {
  transform: translate(0px, 0px);
  transition: transform 220ms cubic-bezier(0, 0, 0.2, 1) 0ms;
}
.right-enter,
.right-leave-to {
  transform: translateX(100vw) translateX(0px);
}
</style>
